
import Vue from 'vue';


export default Vue.extend({
  props: {
    // visible: {
    //   type: Boolean,
    //   required: true
    // } as PropOptions<boolean>,
  }
})
